import { render } from "./App.vue?vue&type=template&id=6bcfa8c3&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=6bcfa8c3&lang=scss"

import exportComponent from "E:\\Sync\\Work\\Node\\Publish\\bao-tool-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__